module.exports = __webpack_public_path__ + "img/img_logo.d2a36d13.svg";